import { mainSiteUrl } from '@/data/categories';

export default function CTASection() {
  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="rounded-[28px] overflow-hidden mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Creative%20diagonal%20flat%20lay%20product%20collage%20with%20sneakers%20positioned%20at%20the%20top%20left%20a%20folded%20hoodie%20in%20the%20center%20and%20accessories%20scattered%20along%20the%20lower%20right%20on%20a%20warm%20terracotta%20toned%20surface%20with%20dramatic%20side%20lighting%20from%20the%20upper%20left%20creating%20strong%20geometric%20shadows%20and%20rich%20warm%20amber%20tones%20editorial%20fashion%20product%20photography%20with%20artistic%20composition%20and%20bold%20contrast&width=1600&height=500&seq=cta-collage-v2&orientation=landscape"
            alt="Superbuy Spreadsheet - buy smarter with organized shopping"
            title="Superbuy Spreadsheet organized shopping"
            className="w-full h-[240px] md:h-[360px] object-cover object-top"
          />
        </div>

        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-heading leading-tight text-foreground-950 mb-4">
            Buy <span className="italic font-normal text-foreground-500">smarter</span> with{' '}
            <span className="font-bold">Superbuy Spreadsheet</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-10 leading-relaxed">
            Join thousands of savvy shoppers who use our spreadsheet system to organize,
            compare, and purchase products from China with confidence.
          </p>

          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center justify-center px-10 py-4 bg-foreground-950 text-background-50 font-semibold text-sm rounded-full hover:bg-foreground-800 transition-all duration-200 cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line ml-2 text-base" />
          </a>
        </div>
      </div>
    </section>
  );
}